module.exports = __webpack_public_path__ + "static/media/screen3.4c02e342.png";